import { convertObjectToFormData } from "src/lib/convertObjectToFormData";
import { api } from "src/services/api";

type BodyCheckSpinStatus = {
  email: string | null;
  type: string | null;
};

export const useSpinStatus = () => {
  return {
    checkSpinStatus({ email, type }: BodyCheckSpinStatus) {
      return api({
        method: "post",
        data: convertObjectToFormData({ email, type }),
        url: "checkAttempt",
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
  };
};
